<form [formGroup]="userdataForm" class="standard-form" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="fill">
    <mat-label>{{'FirstName' | translate }}</mat-label>
    <input matInput formControlName="firstName" [errorStateMatcher]="matcher" placeholder="Wprowadź imię...">
    @if (userdataForm.controls['firstName'].hasError('minlength') && !userdataForm.controls['firstName'].hasError('required')) {
      <mat-error>
        {{'FieldRequiredMoreThanTwoChar' | translate }}
      </mat-error>
    }
    @if (userdataForm.controls['firstName'].hasError('required')) {
      <mat-error [innerHtml]="'FieldRequired' | translate">
      </mat-error>
    }
  </mat-form-field>
  <br>

    <mat-form-field appearance="fill">
      <mat-label>{{'LastName' | translate }}</mat-label>
      <input matInput formControlName="lastName" placeholder="Wprowadź nazwisko...">
      @if (userdataForm.controls['lastName'].hasError('minlength') && !userdataForm.controls['lastName'].hasError('required')) {
        <mat-error>
          {{'FieldRequiredMoreThanTwoChar' | translate }}
        </mat-error>
      }
      @if (userdataForm.controls['lastName'].hasError('required')) {
        <mat-error [innerHtml]="'FieldRequired' | translate">
        </mat-error>
      }
    </mat-form-field>
    <br/>

    <mat-form-field appearance="fill">
      <mat-label>{{'CompanyName' | translate }}</mat-label>
      <input matInput formControlName="additionalDataValue" placeholder="Wprowadź pełną nazwę firmy..." >
      @if (userdataForm.controls['additionalDataValue'].hasError('minlength') && !userdataForm.controls['additionalDataValue'].hasError('required')) {
        <mat-error>
          {{'FieldRequiredMoreThanTwoChar' | translate }}
        </mat-error>
      }
      @if (userdataForm.controls['additionalDataValue'].hasError('required')) {
        <mat-error [innerHtml]="'FieldRequired' | translate">
        </mat-error>
      }
    </mat-form-field>
    <br/>
    <!--
    <mat-form-field appearance="fill">
      <input type="hidden" [ngModelOptions]="{standalone: true}" [(ngModel)]="value" [matDatepicker]="picker" placeholder="Choose a date">
      <input matInput type="text" [min]="minDate" [max]="maxDate"  [textMask]="datemask" [ngModel]="userdataForm.get('date').value | date : userdataForm.get('date').value !== null?'dd/MM/yyyy' : ''"
        [ngModelOptions]="{standalone: true}" (blur)="onBlur()" (change)='todate($event.target.value)' (click) = "picker.open()" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field> -->

      <mat-form-field appearance="fill">
        <mat-label>{{'BirthDate' | translate }}</mat-label>
        <input matInput   formControlName="customerIdentifier" type="text" (click)="picker.open()" [matDatepicker]="picker" [min]="minDate" [max]="maxDate" placeholder="Wybierz datę z kalendarza..." >
        @if (userdataForm.controls['customerIdentifier'].hasError('minlength') && !userdataForm.controls['customerIdentifier'].hasError('required')) {
          <mat-error>
            {{'FieldRequiredMoreThanTwoChar' | translate }}
          </mat-error>
        }
        @if (userdataForm.controls['customerIdentifier'].hasError('required')) {
          <mat-error [innerHtml]="'FieldRequired' | translate">
          </mat-error>
        }
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker touchUi #picker startView="multi-year" disabled="false"></mat-datepicker>
      </mat-form-field>


      <div class="cbx-accept">
        @if (isContractor) {
          <mat-checkbox formControlName="kbwAccept"
            class="example-margin">
            {{'KbwAcceptBook' | translate }}
          </mat-checkbox><br><br>
          <mat-checkbox formControlName="regulationAccept"
            class="example-margin">
            {{'AcceptKBWRules' | translate }}
          </mat-checkbox>
          <br><br>
          <mat-checkbox formControlName="dataProcessAccept"
            class="example-margin">
            {{'AcceptPersonalData' | translate }}
          </mat-checkbox><br><br>
          <span>{{'KbwAcceptPrivacyRules' | translate}}
          </span>
        } @else {
          <mat-checkbox formControlName="kbwAccept"
            class="example-margin">
            {{'KbwGuestAcceptBook' | translate }}
          </mat-checkbox><br><br>
          <mat-checkbox formControlName="regulationAccept"
            class="example-margin">
            {{'AcceptKBWGuestRules' | translate }}
          </mat-checkbox>
          <br><br>
          <mat-checkbox formControlName="dataProcessAccept"
            class="example-margin">
            {{'AcceptPersonalData' | translate }}
          </mat-checkbox><br><br>
          <span>{{'KbwGuestAcceptPrivacyRules' | translate}}
          </span>
        }
      </div>
      <!-- <button (click)="executeImportantAction()">Important action</button> -->
      <br>
        <div class="form-btn-wrapper">
          <button mat-raised-button color="primary" type="submit" [disabled]="!userdataForm.valid">
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            {{'Next' | translate }}
          </button>
        </div>
      </form>
